// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "table[data-v-6d134920]{border-collapse:collapse}thead[data-v-6d134920]{background-color:grey}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
